import React from "react";
import {
  Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Table
} from "reactstrap";
import LoaderUI from '../../../../components/common/loader';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toasterConfig, pagination } from "../../../../utils/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";



toast.configure();

const EditReadOnlyPermission = ({  showPermissionModal,setShowPermissionModal,unlockDocument }) => {


  return (
    <>
      <Modal isOpen={showPermissionModal}
        backdrop="static">
        <ModalHeader>
        </ModalHeader>
        <ModalBody>
          <label>
           As a TRAINED admin do you wish to unlock this document ?
          </label>
        </ModalBody>
        <ModalFooter>
          <Button color="link" onClick={()=>unlockDocument()} className="cancel-btn">
            Yes
          </Button>
          <Button color="secondary" onClick={()=>setShowPermissionModal()} >
            No
          </Button>
        </ModalFooter>

      </Modal>
    </>
  );
};

export default EditReadOnlyPermission;
